<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                  ref="form">
                                <FormItem :label="t.post.name" prop="name">
                                    <Input v-model="formItem.name" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.post.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.post.code" prop="code">
                                    <Input v-model="formItem.code" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.post.code)"></Input>
                                </FormItem>
                                <FormItem :label="t.post.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.post.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.post.open}}</span>
                                        <span slot="close">{{t.post.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem :label="t.post.remark" prop="remark">
                                    <Input v-model="formItem.remark" :maxlength="200"
                                           :autosize="{minRows: 3,maxRows: 3}"
                                           :placeholder="msgUtil.placeholderRequired(t.post.remark)"
                                           type="textarea"></Input>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { edit, getPostInfo } from '@/api/post';

export default {
    name: 'organization_post_edit',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItemBk: {},
            formItem: {
                name: '',
                code: '',
                status: '1',
                sortOrder: 0,
                remark: '',
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.post.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.post.name, 32),
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.post.code),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.post.code, 32),
                        trigger: 'blur',
                    },
                ],
                remark: [
                    {
                        type: 'string',
                        max: 200,
                        message: msgUtil.errorMaxLengthFullWidth(t.post.remark, 200),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    let postDto = {};
                    postDto.name = this.formItem.name;
                    postDto.code = this.formItem.code;
                    postDto.sortOrder = this.formItem.sortOrder;
                    postDto.status = this.formItem.status;

                    const res = await edit(this.$route.params.id, postDto);
                    Object.assign(this.formItemBk, this.formItem);
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.loading = false;
        },
        async init() {
            const postInfo = await getPostInfo(this.$route.params.id);
            if (postInfo.post != null) {
                this.formItem = postInfo.post;
                Object.assign(this.formItemBk, postInfo.post);
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
